export class AmortizacionDetalle{
    public constructor(
        public id: String = "",
        public cuota: number = 0,
        public fecha_vencimiento: String = "",
        public estado_cuota: String = "",
        public saldo: String = "",
        public empresa_id: String = "",
        public amortizacion_id: String = "",
        public usuario_id: String = "",
    ){
        //
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/amortizacion_detalle.ts